const errorHandler = require('./errorHandler');

function ApiService($q, $http, ConfigEnvironment) {
  'ngInject';
  this.checkGreenbackConnection = function () {
    return $http.get(ConfigEnvironment.getApiUrl("greenback") + '/pages')
  };
  this.checkAdvertisingConnection = function () {
    return $http.get(ConfigEnvironment.getApiUrl("advertising") + '/redemptions/paginateWithUningested')
  };

  this.errorHandler = errorHandler;
}

export default ApiService;



// WEBPACK FOOTER //
// ./js/containers/core/services/api.service.js